export default "__VITE_ASSET__7148e814__"